import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { mediaActions } from '../../_actions';
import { Loader } from '../../_components';

import Images from './_components/Images.component';
import ModalComponent from './_components/Modal.component';
import './MediaPanel.scss';

class MediaPanelContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      media: [],
      loaded: false,
      shouldShowModal: false
    }

    this.listMedia = this.listMedia.bind(this);
    this.handleModalDisplay = this.handleModalDisplay.bind(this);
  }

  listMedia() {
    const { dispatch } = this.props;
    dispatch(mediaActions.listMediaByDomain(queryString.parse(this.props.location.search).domain))
      .then(res => {
        if ( res.type === "LIST_MEDIA_FAILURE" ) return;
        this.setState({media: res.data.data, loaded: true});
      });
  }

  componentDidMount() {
    this.listMedia();
  }

  handleModalDisplay(e) {
    if ( e ) {
      return this.setState({shouldShowModal: e.target.getAttribute('data-modal-display')});
    }
    return this.setState({shouldShowModal: false});
  }

  render() {
    const { media, loaded } = this.state;

    return (
      <>
        <section className="component component-media">
          <div className="component-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col">
                  <h1 className="title">Mídias</h1>
                </div>
                {
                  media.length !== 0 ?
                    <div className="col hidden-xs visible-lg">
                      <button type="button" className="btn btn-white float-right add-media-btn" data-modal-display={true} onClick={this.handleModalDisplay}><i className="linearicons-plus-circle"></i> Adicionar mídias</button>
                    </div>
                  : null
                }
              </div>
            </div>
          </div>
          <div className="component-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col">
                  {
                    loaded ?
                      media.length !== 0 ?
                        <div className="card card-images">
                          <div className="card-header">
                          </div>
                          <div className="card-body">
                            <div className="image-group">
                              {
                                media.map((img, index) => {
                                  return <Images key={index} {...img} />
                                }) 
                              }
                            </div>
                          </div>
                        </div>
                      : <div className="no-media">
                          <p>Não foram encontradas mídias para esse domínio.</p>
                          <button className="btn btn-white" data-modal-display={true} onClick={this.handleModalDisplay}><i className="linearicons-plus-circle"></i> ADICIONAR MÍDIAS</button>
                        </div>
                    : <Loader />
                  }
                </div>
              </div>
            </div>
          </div>
        </section>

        <ModalComponent parentState={this.state} parentProps={this.props} handleModalDisplay={this.handleModalDisplay} handleReload={this.listMedia}/>
      </>
    )
  }
}

function mapStateToProps(state) {
  const { listMediaReducer } = state.listMediaReducer;
  return listMediaReducer;
}

const ConnectedMediaPanelContainer = connect(mapStateToProps)(MediaPanelContainer);
export { ConnectedMediaPanelContainer as MediaPanel }